/** Polish postal code pattern, e.g. 00-001. */
const POLISH_POSTAL_CODE_PATTERN = /\b\d{2}-\d{3}\b/g;

export const stripPostalCodeFromAddress = (address: string): string =>
    address
        .replace(POLISH_POSTAL_CODE_PATTERN, "")
        .replace(/\s*,\s*,/g, ",")
        .replace(/\s{2,}/g, " ")
        .replace(/^\s*,\s*|\s*,\s*$/g, "")
        .trim();
/** Polish postal code pattern, e.g. 00-001. */
const POLISH_POSTAL_CODE_PATTERN = /\b\d{2}-\d{3}\b/g;

export const stripPostalCodeFromAddress = (address: string): string =>
    address
        .replace(POLISH_POSTAL_CODE_PATTERN, "")
        .replace(/\s*,\s*,/g, ",")
        .replace(/\s{2,}/g, " ")
        .replace(/^\s*,\s*|\s*,\s*$/g, "")
        .trim();
